(function(){
  'use strict';
  angular.module("irricrops")
    .directive('detalleMuestras', [  function() {
      return {
        restrict: "E",
        templateUrl: 'shared/detalleMuestras/detalleMuestras.tmpl.html',
        scope:{
          data:"=",
          cuartel:'=',
          save:"="
        },
        controllerAs: 'dm',
        controller: ["$scope", "$mdToast","productividadFac", 'CONSTANTES', function($scope, $mdToast, productividadFac, CONSTANTES){

          var vm = this;

          vm.data = $scope.data;
          $scope.$watch("data.muestras", function(n){
            vm.calcularPromedio();
          }, true);

          vm.openMenu = function($mdOpenMenu, ev) {
            originatorEv = ev;
            $mdOpenMenu(ev);
          };

          vm.ocultarDetalle = function(){
            vm.data.show = false;
            vm.data.name = "";
          };

          vm.agregarMuestra = function(){
            vm.data.muestras.push({
              cantidad:   '',
              nombre:     '',
              usar:       true
            });
          };

          vm.saveMuestra = function (muestra) {
            muestra.loading = true;
            productividadFac.saveMuestra($scope.cuartel.id, {
              tipo:     vm.data.tipo_muestra,
              nombre:   muestra.nombre,
              cantidad: muestra.cantidad,
              hash:     muestra.hash || '',
              usar:     muestra.usar
            }).success(function(res){
              muestra.loading = false;
              muestra.id      = res.data[0].id;
              muestra.hash    = res.data[0].hash;
              vm.calcularPromedio();
            });
          };

          vm.cancelBorrarMuestra = function(){
          };



          vm.borrarMuestra = function(muestra){
            if(angular.isDefined(muestra)){

              var successFn = function(res){
                angular.forEach(vm.data.muestras, function(muestraBusqueda, indice){
                  if(muestraBusqueda.id == muestra.id) {
                    vm.data.muestras.splice(indice,1);
                  }
                });
                var toast = $mdToast.simple()
                  .textContent('Borrado')
                  // .action('deshacer')
                  .position(CONSTANTES.TOAST_POSITION);
                $mdToast.show(toast);
                // $mdToast.show(toast).then(function(response) {
                //   if ( response == 'ok' ) {
                //     alert('deshecho');
                //   }
                // });
              };


              if(angular.isUndefined(muestra.hash) || muestra.hash === ""){
                successFn();
              }else{
                productividadFac.deleteMuestra(muestra).success(successFn);
              }

            }
          };

          vm.usarPromedio = function(){
            vm.data.cantidad = vm.data.promedio;
            $scope.cuartel.datos_tabla[vm.data.name].cantidad = vm.data.cantidad;
            $scope.save($scope.cuartel, vm.data.name);
          };

          vm.calcularPromedio = function(){
            var cantidad = 0;
            var total = 0;
            angular.forEach(vm.data.muestras, function(muestra){
              if(muestra.usar && isNumeric(muestra.cantidad)){
                total += parseFloat(muestra.cantidad);
                cantidad ++;
              }
            });
            vm.data.promedio = total/cantidad;
          };



          //http://stackoverflow.com/questions/18082/validate-decimal-numbers-in-javascript-isnumeric
          //TODO remplazar por angular.isNumeric ??
          function isNumeric(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
          }


        }]
      };
    }]);
})();
